export default function QuoteBreak() {
  return (
    <div
      className="py-[110px] px-[60px] border-t border-[#1e1a18] text-center max-md:px-6"
      style={{
        fontFamily: "'Work Sans', sans-serif",
        background:
          'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(172,18,28,0.05), transparent 70%), #060606',
      }}
    >
      <p
        className="font-black text-[#faf9f7] leading-[1.05] max-w-[900px] mx-auto mb-7 tracking-[-0.01em]"
        style={{
          fontFamily: "'Big Shoulders Display', sans-serif",
          fontSize: 'clamp(36px, 5vw, 68px)',
        }}
      >
        She isn&apos;t a clone.
        <br />
        But if you could be in{' '}
        <em className="text-[#d43742] not-italic">two places at once</em> —<br />
        this is as close as you&apos;ll ever get.
      </p>
      <p className="text-[15px] font-light text-[#e0dbd5] tracking-[0.04em]">
        delegate.petergits.com
      </p>
    </div>
  );
}
